import React from 'react'

const Carrier = () => {
  return (
    <>

      <div className='container'>
        <div className='container'>
          <h2 className='text-muted fw-bold mt-5'>Careers</h2>
          <p className='mt-5 mb-5'>We are always looking for dedicated and dynamic individuals to join our team. To apply, write to us at properties@dharnigroup.com</p>
        </div>
      </div>

    </>
  )
}

export default Carrier;